import ReviewsTab from '../ReviewTab/ReviewsTab';
import { Flex } from '@chakra-ui/react';
import { IRoleType } from '@publishing-engine/domain/models';
import { useEffect } from 'react';
import { useSubmissionReviewsData } from 'src/contexts/SubmissionReviewsDataProvider';

type Props = {
  roleContext: IRoleType;
};

const PeerReviewsTab = ({ roleContext }: Props) => {
  const { resetFilters } = useSubmissionReviewsData();

  useEffect(() => {
    const timer = setTimeout(() => {
      resetFilters();
    }, 0);

    return () => {
      clearTimeout(timer);
      resetFilters();
    };
  }, []);

  return (
    <Flex width="100%" flexDirection="column">
      <ReviewsTab roleContext={roleContext} />
    </Flex>
  );
};
export default PeerReviewsTab;
